import React, { useMemo, useState } from 'react';
import { useTranslation } from 'utils/i18n';
import sharedTranslations from '../shared/translations';
import { interactive, spacing, typography } from './docsStyles';

/**
 * Simple client-side search across sections (title/content).
 * Uses standardized styling for consistency.
 * onSearch(resultsSections) -> caller renders the filtered sections
 */
const DocsSearch = ({ sections = [], onSearch }) => {
  const { language } = useTranslation();
  const [q, setQ] = useState('');
  
  // Get translations - memoized to update when language changes
  const translations = useMemo(() => {
    const t = sharedTranslations[language] || sharedTranslations.en;
    return {
      placeholder: t?.legal?.search?.placeholder || 'Search in document…',
      ariaLabel: t?.legal?.search?.ariaLabel || 'Search in document'
    };
  }, [language]);

  const filterSections = (items, text) => {
    if (!text) return items;
    const t = text.toLowerCase();
    const matchSection = (s) => {
      const titleMatch = (s.title || '').toLowerCase().includes(t);
      const contentStr = Array.isArray(s.content) ? s.content.join('\n') : (s.content || '');
      const contentMatch = contentStr.toLowerCase().includes(t);
      let children = [];
      if (s.children && s.children.length > 0) {
        children = s.children.map(matchSection).filter(Boolean);
      }
      if (titleMatch || contentMatch || children.length > 0) {
        return { ...s, children };
      }
      return null;
    };
    return items.map(matchSection).filter(Boolean);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQ(value);
    const results = filterSections(sections, value);
    onSearch && onSearch(results);
  };

  const containerStyle = {
    marginBottom: spacing.md
  };

  const inputStyle = {
    ...interactive.input,
    fontSize: typography.body.fontSize
  };

  return (
    <div style={containerStyle}>
      <input
        type="search"
        placeholder={translations.placeholder}
        value={q}
        onChange={handleChange}
        aria-label={translations.ariaLabel}
        style={inputStyle}
        onFocus={(e) => {
          e.target.style.borderColor = '#0ea5e9';
          e.target.style.boxShadow = '0 0 0 3px rgba(14, 165, 233, 0.1)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  );
};

export default DocsSearch;




